const isValidName = (fullName: string): boolean => {
  const tokenizedName = fullName.trim().split(' ');
  // If more than two tokens provided, the last words will be joined by space and set as the last name
  return Boolean(tokenizedName.length > 1 && tokenizedName[1].length);
};

export default isValidName;
